<div class="currentClass" *ngIf="inseason">
<div class="row orders_rowsection">
<div class="col-xs-12 orders_graphtitle">
    Current Season Status<span class="orders_graphsubtitle">{{inseason}}</span>
</div>
<div id="ordergraphcontainer" [chart]="columnChart"></div>
</div>  
</div>    
<app-new-orders></app-new-orders>             